import { vysionTrack } from './vysionService';

export const setPurchaseVysion = (param: any): void => {
  switch (param.event) {
    case 'BUY CREDITS NAVBAR':
      vysionTrack(param, 'navBar-buyCredits');
      break;
    case 'BUY CREDITS ACCTMENU':
      vysionTrack(param, 'accountMenu-buyCredits');
      break;
    case 'SUFFICIENT CREDITS UNLOCK':
      vysionTrack(param, 'messages-sufficientCredits-unlock');
      break;
    case 'INSUFFICIENT CREDITS UNLOCK':
      vysionTrack(param, 'messages-insufficientCredits-unlock');
      break;
    case 'BUY 1000 CREDITS':
      vysionTrack(param, 'packages-1000Credits');
      break;
    case 'BUY 500 CREDITS':
      vysionTrack(param, 'packages-500Credits');
      break;
    case 'BUY 100 CREDITS':
      vysionTrack(param, 'packages-100Credits');
      break;
    default:
      return;
  }
};
